export default "__VITE_ASSET__BkEy$GKT__"